import TopBar from '../../components/Layout/TopBar';
import MyButton from '../../components/Layout/MyButton';
import { faArrowLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import PdfGenerator from '../../components/Dossier/PdfGenerator';
import moment from 'moment';
import DevisPDF from './DevisPDF';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import useAuthz from '../../hooks/useAuthz';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { FACTURATION_TYPE, PROFIL } from '../../constants/enum';
import { logError } from '../../components/Utils/FormatData';

const css = {
    container: { height: '90%', width: '90%', backgroundColor: 'white', borderRadius: '5px', overflow: 'hidden' },
    fullRow: { height: '100%', width: '100%', alignItems: 'center' },
    row: { height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal' },
    rowValidation: { height: '60px', flexDirection: 'column', justifyContent: 'normal', alignItems: 'flex-end' },
};

const devisRef = React.createRef();

const DevisViewer = (props) => {
    const facturation_id = new URLSearchParams(location.search).get('id') || 0;
    const { color, type } = props.params;
    const alert = useAlert();
    const navigate = useNavigate();
    const [authz, user, profil] = useAuthz();
    const [isLoading, setIsLoading] = useState(false);
    const [dossier, setDossier] = useState(null);
    const [idSelectedDossier, setIdSelectedDossier] = useState(null);
    const [saveDossier, setSaveDossier] = useState(null);
    const [signature, setSignature] = useState(null);
    const [legalNotice, setLegalNotice] = useState(null);
    const [particularNotice, setParticularNotice] = useState(null);

    //#region useEffect

    // Initialisation du composant
    useEffect(() => {
        if (profil.profil === 6) {
            alert.error('Vous n\'êtes pas autorisé à accéder à cette page');
            navigate('/');
        } else {
            document.title = type === FACTURATION_TYPE.DEVIS ? 'TE - Consultation de devis' : 'TE - Consultation de facture';
            fetchLoad(facturation_id);
            getSignature();
            apiGetLegalNotice();
            apiGetParticularNotice();
        }
    }, []);

    // endregion

    // region API
    const fetchLoad = () => {
        axios({ method: 'get', url: `${URL_API}/facturation/fact-by-id`, params: { id: facturation_id } })
        .then((response) => {
            setDossier(response.data);
        })
        .catch((error) => {
            alert.removeAll();
            alert.error(error.message);
        });
    };

    const getSignature = () => {
        axios({ method: 'get', url: URL_API + '/parameters/get-by-key', params: { key: 'SIGNATURE_PDF' } })
        .then((response) => {
            setSignature(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };

    const apiGetLegalNotice = () => {
        axios({ method: 'get', url: URL_API + '/parameters/get-by-key', params: { key: 'LEGAL_NOTICE' } })
        .then((response) => {
            setLegalNotice(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };

    const apiGetParticularNotice = () => {
        axios({ method: 'get', url: URL_API + '/parameters/get-by-key', params: { key: 'PARTICULAR_NOTICE' } })
        .then((response) => {
            setParticularNotice(response.data);
        })
        .catch((error) => {
            logError(alert, error);
        });
    };


    const getFilename = () => {
        let filename = type === FACTURATION_TYPE.DEVIS ? '[Devis]' : '[Facture]';
        let requestPass = dossier.dossier;
        let departements = type === FACTURATION_TYPE.DEVIS ? requestPass?.metadata.reference.departments : dossier.elements_factures.status.departement;
        let departmentsFormatted = departements.join('_');
        departmentsFormatted = departmentsFormatted.replace(/\s/g, '-');

        filename += `_[${requestPass.id}-${requestPass.metadata.reference.numDossier}-${departmentsFormatted}]`;
        filename += `_[${moment().format('DD/MM/YYYY_HH:mm')}]`;
        return filename;
    };
    //#endregion

    // region méthode
    const onSaveDevisBtnClick = () => {

        axios({
            method: 'get',
            url: devisRef.current.attributes.src.value,
            responseType: 'blob',
        }).then((response) => {
            var reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onloadend = function() {
                let base64data = reader.result.split(',')[1];

                axios({
                    method: 'post',
                    url: `${URL_API}/facturation/save-document`,
                    data: {
                        id: 0,
                        data: base64data,
                        fileName: (type === FACTURATION_TYPE.DEVIS ? 'Devis' : 'Facture') + ' n° [' + facturation_id + ']',
                        mimeType: 'application/pdf',
                    },
                    params: { id: facturation_id, type: type.toUpperCase(), userAction: user.user_id },
                })
                .then((response) => {
                    alert.removeAll();

                    if (type === FACTURATION_TYPE.DEVIS) {
                        alert.success(`Le devis a été sauvegardé`);

                        if (profil.profil === 1 || profil.profil === 2) {
                            axios({
                                method: 'post',
                                url: `${URL_API}/facturation/send-quotation`,
                                params: { requestPassId: dossier.dossier.id, userAction: user.user_id },
                            })
                            .then((response) => {
                                if (response.data) {
                                    alert.removeAll();
                                    alert.success('La notification a bien été envoyée!');
                                }
                            })
                            .catch((error) => {
                                logError(alert, error);
                            });
                        }

                    } else {
                        alert.success(`La facture a été sauvegardée`);
                    }
                })
                .catch((error) => {
                    alert.removeAll();
                    alert.error(error.message);
                });
            };
        }).catch((err) => {
            alert.error(err);
        });
    };
    // endregion

    const MyDocument = () => (
        <PdfGenerator
            title={dossier && getFilename()}
            template={dossier && <DevisPDF data={dossier} type={type} signature={signature} legalNotice={legalNotice}
                                           particularNotice={particularNotice} />}
        />
    );

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <TopBar title={(type === FACTURATION_TYPE.DEVIS ? 'Devis' : 'Facture') + ' n° [' + facturation_id + ']'}
                    className='topbar-contenu' color={'#f18d2d'}
                    buttons={
                        <div className='topbar-buttons'>
                            <MyButton
                                label={(type === FACTURATION_TYPE.DEVIS ? 'Retour aux devis' : 'Retour aux factures')}
                                icon={faArrowLeft}
                                onClick={() => {
                                    navigate(`/facturation${type === FACTURATION_TYPE.FACTURE ? '?type=facture' : ''}`);
                                }}
                                sx={{ backgroundColor: '#b76618 !important' }}
                            />
                        {(profil.profil !== PROFIL.INTERVENANT) &&
                            <MyButton
                                label={(type === FACTURATION_TYPE.DEVIS ? 'Sauvegarder et notifier le client' : 'Valider et sauvegarder')}
                                icon={faSave} onClick={() => {
                                onSaveDevisBtnClick();
                            }} sx={{ backgroundColor: '#b76618 !important' }} />
                        }

                            {dossier &&
                                <PDFDownloadLink document={<MyDocument />} fileName={getFilename() + '.pdf'}>
                                    {({ blob, url, loading, error }) =>
                                        loading ? <MyButton label='Génération...' icon={faFilePdf} disabled={true} /> :
                                            <MyButton label='Télécharger' icon={faFilePdf}
                                                      sx={{ backgroundColor: '#b76618 !important' }} />
                                    }
                                </PDFDownloadLink>
                            }
                        </div>
                    }
            />
            {isLoading && <div className='row' style={css.fullRow}>
                <ClipLoader color='#0094ca' loading={isLoading} size={75}
                            css={'display: flex; margin: 25px;justify-content: center;'} />
            </div>}

            <div className='row' style={{ height: '95%', width: '100%' }}>
                <PDFViewer style={{ width: '100%', height: '99%' }} innerRef={devisRef} showToolbar={false}>
                    <MyDocument />
                </PDFViewer>
            </div>
        </div>
    );
};

export default DevisViewer;